import React, { useState } from 'react';
import './ProductTabs.css';

export default function ProductTabs({
    activeTab,
    onTabChange,
    tabCounts,
    onSearchChange,
    searchQuery,
    onRefresh = () => {},
    isRefreshing = false
}) {
    const [showSearch, setShowSearch] = useState(false);
    
    const tabs = [
        { key: 'all', label: 'All', count: tabCounts.all },
        { key: 'active', label: 'Active', count: tabCounts.active },
        { key: 'sold', label: 'Sold', count: tabCounts.sold },
        { key: 'draft', label: 'Draft', count: tabCounts.draft }
    ];

    const handleSearchToggle = () => {
        setShowSearch(!showSearch);
        if (showSearch && searchQuery) {
            // Clear search when hiding the search field
            onSearchChange('');
        }
    };

    const handleSearchInput = (e) => {
        onSearchChange(e.target.value);
    };

    return (
        <div className="product-tabs-container">
            <div className="product-tabs">
                {tabs.map(tab => (
                    <button
                        key={tab.key}
                        className={`tab-button ${activeTab === tab.key ? 'active' : ''}`}
                        onClick={() => onTabChange(tab.key)}
                    >
                        {tab.label} <small>({tab.count})</small>
                    </button>
                ))}
                <button 
                    className="refresh-button"
                    onClick={onRefresh}
                    title="Refresh products"
                    aria-label="Refresh products"
                    disabled={isRefreshing}
                >
                    <i className={`fa-solid ${isRefreshing ? 'fa-spinner fa-spin' : 'fa-rotate-right'}`}></i>
                </button>
                <button 
                    className="search-toggle-button"
                    onClick={handleSearchToggle}
                    title="Search products"
                    aria-label="Toggle search"
                >
                    <i className={`fa-solid ${showSearch ? 'fa-times' : 'fa-search'}`}></i>
                </button>
            </div>
            {showSearch && (
                <div className="product-search-field">
                    <input
                        type="text"
                        placeholder="Search products..."
                        value={searchQuery}
                        onChange={handleSearchInput}
                        autoFocus
                        aria-label="Search products"
                    />
                </div>
            )}
        </div>
    );
}